// /CoreWrapper/cores/composeCores.js

export const composeCores = (BaseComponent, cores = []) =>
	cores.reduce((Accumulated, coreFn) => coreFn(Accumulated), BaseComponent)
